import {WOW} from 'wowjs'

window.addEventListener('load', function() {
  const wow = new WOW({
    boxClass: 'wow',
    animateClass: 'animated',
    offset: 0,
    mobile: true,
  });
  wow.init();
});
